import { breakpoints } from './breakpoints';
var xs = breakpoints.xs, sm = breakpoints.sm, md = breakpoints.md, lg = breakpoints.lg, xl = breakpoints.xl;
/**
 * @deprecated since version 18.0.0
 */
export var customMediaQuery = function (maxWidth, minWidth) {
    if (minWidth === void 0) { minWidth = xs.min; }
    return "@media (min-width: " + minWidth + "px) and (max-width: " + maxWidth + "px)";
};
export var media = {
    /**
     * @deprecated since version 18.0.0
     */
    mobile: customMediaQuery(sm.max),
    tablet: customMediaQuery(md.max),
    desktop: customMediaQuery(lg.max),
    widescreen: customMediaQuery(xl.max),
    onlyTablet: customMediaQuery(md.min, md.max),
    /**
     * New key names prevent breaking changes and decouple breakpoint from devices.
     * Defaulting to a tiered 'min-width' will encourage mobile-first.
     * @since 1.5.2
     *
     * @example
     * const SomeWidget = styled.article`
     *   // Generic styles first…
     *   width: 100%
     *   // Then mobile…
     *   ${get.media('>=small')} {
     *     max-width: 200px
     *   }
     *   // Then tablet…
     *   ${get.media('>=medium')} {
     *     max-width: 400px
     *   }
     * `
     *
     * @todo Create these programmatically once `breakpoints.ts` is consistent.
     */
    '< small': "@media screen and (max-width: " + xs.max + "px)",
    '>=small': "@media screen and (min-width: " + sm.min + "px)",
    'small-only': "@media screen and (min-width: " + sm.min + "px) and (max-width: " + sm.max + "px)",
    '< medium': "@media screen and (max-width: " + sm.max + "px)",
    'medium-only': "@media screen and (min-width: " + md.min + "px) and (max-width: " + md.max + "px)",
    '>=medium': "@media screen and (min-width: " + md.min + "px)",
    '< large': "@media screen and (max-width: " + md.max + "px)",
    'large-only': "@media screen and (min-width: " + lg.min + "px) and (max-width: " + lg.max + "px)",
    '>=large': "@media screen and (min-width: " + lg.min + "px)",
    '>=huge': "@media screen and (min-width: " + xl.min + "px)",
};
/**
 * EXAMPLE of how to use
 *
 * const Component = styled.div`
 *  height: 100px;
 *  width: 100px;
 *  background: blue;

    // background for desktop size
    ${media.desktop} {
      background: black;
    }
    // background for tablet size
    ${media.tablet} {
      background: white;
    }
    // background for mobile size
    ${media.mobile} {
      background: red;
    }
  `
 */
export default media;
//# sourceMappingURL=media.js.map